import formBaseMixin from '../../../components/form/form-base-mixin.js'
import url from "../../../utils/url";

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      fields: {
        name: '',
        garbage_source_category_id: '',
        calculation_unit_id: '',
        tariff_branch_id: '',
        fias_locality: [],
        normativ_characteristic_id: ''
      }
    }
  },
  computed: {
    disabledInEditMode () {
      if (this.itemId) {
        return true
      }
      return false
    },
    formTitle () {
      if (this.itemId && this.item) {
        return this.item.name
      }
      return 'Добавление норматива'
    },
    collection () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    },
    calculationUnit () {
      return this.collection.calculation_unit || []
    },
    garbageCategory () {
      return this.collection.garbage_category || []
    },
    unclosedTariff () {
      return this.$store.getters.readUrlEndpoint(
        this.getUnclosedTariffEndpoint(this.$route)
      ).data
    },
    fias () {
      return this.$store.getters.readUrlEndpoint(
        this.getFiasEndpoint()
      )
    },
    normativCharacteristic () {
      return this.collection.normativ_characteristic || []
    }
  },
  methods: {
    zoneOptionTextFunc (name, deep, child) {
      if (deep < 1) {
        return name
      }
      return `${child.shortname} ${child.offname}`
    },
    convertFiasLocalityToArray (fiasLocality) {
      const items = []
      if (Array.isArray(fiasLocality)) {
        fiasLocality.forEach(f => {
          items.push(f.fias_locality_guid)
        })
      }
      return items
    },
    update () {
      if (this.item) {
        this.fields = Object.assign({}, this.item)
        this.fields.fias_locality = this.convertFiasLocalityToArray(this.item.fias_locality)
      }
    },
    /**
     * @override
     */
    getRedirectParams () {
      if (this.itemId) {
        return formBaseMixin.methods.getRedirectParams.call(this)
      }
      let route = url.getRoute(this.$route)
      let routeNameParts = route.name.split('.')
      routeNameParts.pop()
      return {
        name: routeNameParts.join('.') + '.update',
        params: {id: this.fields.id},
        query: route.query
      }
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    const promises = []
    const endpoints = [
      methods.getItemEndpoint,
      methods.getUnclosedTariffEndpoint
    ]

    endpoints.forEach(endpointFunc => {
      let endpoint = endpointFunc(route, fromRoute)
      if (endpoint) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint}))
      }
    })

    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getCollectionEndpoint(),
      fromCache: true
    }))

    if (methods.getFiasEndpoint) {
      promises.push(store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getFiasEndpoint(),
        fromCache: true
      }))
    }

    return promises.length
      ? Promise.all(promises)
      : Promise.resolve(true)
  }
}
